import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

const domain = process.env.REACT_APP_DOMAIN_NAME;
const apiVersion3 = process.env.REACT_APP_API_VERSION3;

export type PublicCollectionEngagementType =
  | 'collection_page_view'
  | 'collection_video_play'
  | 'collection_audio_play'
  | 'collection_resource_click';

export interface PublicEngagementEventParams {
  engagementType: PublicCollectionEngagementType;
  contentCollectionId: number;
  clientId?: number;
  snippetId?: string;
  listenerAudioPlaybackId?: number;
  metaData?: Record<string, string | number | boolean>;
}

const postPublicEngagementEvent = async (params: PublicEngagementEventParams) => {
  return axios.post(
    `${domain}${apiVersion3}/public/events/engagement`,
    {
      engagement_type: params.engagementType,
      content_collection_id: params.contentCollectionId,
      client_id: params.clientId,
      snippet_id: params.snippetId,
      listener_audio_playback_id: params.listenerAudioPlaybackId,
      meta_data: params.metaData,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHTTPRequest',
      },
    },
  );
};

export const usePublicEngagementEvent = () => {
  return useMutation(postPublicEngagementEvent);
};
